import React from "react"
import Relay from "react-relay"
import ImgSrcSet from "../elements/ImgSrcSet"
import {
  getPlaceholder,
  createSrcSetForResource,
  getImageSrcFromResource,
  getImageType
} from "../../scripts/resource"
import settingsMessages from "../../messages/settings"
import { injectIntl } from "react-intl"

/**
 * Display a single image for this resource,
 * If this is a parent resource without an image it will pull the first
 * image from its children ( checks first 2 )
 */
class ResourceImage extends React.Component {
  render() {
    const { resource, intl, ...props } = this.props

    // search me and my children
    const files = [resource].concat(
      "children" in resource
        ? resource.children.edges.map(child => child.node)
        : []
    )

    //Get first image, else default to a placeholder
    const image = files.reduce(this._getImageData, null) || {
      src: getPlaceholder(
        resource.type,
        intl.formatMessage(settingsMessages.authenticAccountId)
      ).small,
      srcSet: []
    }

    return (
      <ImgSrcSet
        {...props}
        src={image.src}
        srcSet={image.srcSet}
        imgAlt={resource.title}
      />
    )
  }

  _getImageData = (image, resource) => {
    //Just get the first
    if (!image) {
      const imageSize = this.props.imageSize || "medium"
      const src =
        getImageSrcFromResource(
          resource,
          imageSize,
          getImageType(resource),
          false
        ) || JSON.parse(resource.custom_fields).cover_image_link

      if (src) {
        return {
          src: src,
          srcSet: createSrcSetForResource(resource, getImageType(resource))
        }
      }
    }

    return image
  }
}

export default Relay.createContainer(injectIntl(ResourceImage), {
  fragments: {
    resource: () => Relay.QL`
    fragment on Resource {
        id
        type
        title
        custom_fields
        files {
            id
            type
            images {
                small { url width }
                medium { url width }
                large { url width }
            }
        }
        children (first: 2) {
            edges {
                node {
                    id
                    type
                    custom_fields
                    files {
                        id
                        type
                        images {
                            small { url width }
                            medium { url width }
                            large { url width }
                        }
                    }
                }
            }
        }
    }
    `
  }
})



// WEBPACK FOOTER //
// ./webapp/components/modules/ResourceImage.js